import { Button } from "../../Button";

import {
  Container,
  DecorationLeft,
  DecorationRight,
  Content,
  Image,
  MainContent,
  Title,
  Description,
} from "./styles";

export const Desktop = ({ image, title, description, buttonText }) => (
  <Container>
    <DecorationLeft />
    <Content>
      <Image src={image} alt="" />
      <MainContent>
        <Title>{title}</Title>
        <Description>{description}</Description>
        <Button>{buttonText}</Button>
      </MainContent>
    </Content>
    <DecorationRight />
  </Container>
);
